import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=34a5f5b8&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=34a5f5b8&prod&scoped=true&lang=css"
import style1 from "./Feedback.vue?vue&type=style&index=1&id=34a5f5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5f5b8",
  null
  
)

export default component.exports